var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/utils/meta-theme.js
var metaThemeColorElement = document.querySelector("meta[name=theme-color]");
var MetaThemeColor = class {
  /**
   * Set modal color as the theme color.
   */
  setModalColor() {
    const themeColor = "#fff";
    metaThemeColorElement.setAttribute("content", themeColor);
  }
  /**
   * Set modal color as the theme color.
   */
  setAnnouncementBarColor() {
    const themeColor = "#242424";
    metaThemeColorElement.setAttribute("content", themeColor);
  }
  /**
   * Set default color as the theme color.
   */
  setDefaultColor() {
    const announcementBarElement = document.querySelector('announcement-bar[data-role="announcement-bar"]');
    const color = "#fff";
    if (announcementBarElement.classList.contains("js-window-scrolled")) {
      metaThemeColorElement.setAttribute("content", color);
    } else {
      this.setAnnouncementBarColor();
    }
  }
  /**
   * Set custom color as theme color.
   * 
   * @param {string} color 
   */
  setCustomColor(color) {
    metaThemeColorElement.setAttribute("content", color);
  }
};
var meta_theme_default = new MetaThemeColor();

// src/utils/announcement-bar.js
var AnnoucementBar = class {
  constructor() {
    /**
     * Hide announcement bar.
     */
    __publicField(this, "hideAnnouncementBar", () => {
      if (this.headerElement && this.announcementBarElement) {
        const countdownElement = document.querySelector(".announcement-bar__countdown");
        this.annoucementBarState = "closed";
        this.announcementBarElement.classList.add("js-window-scrolled");
        this.announcementBarElement.style.clipPath = "inset(0% 0% 100% 0%)";
        this.headerElement.classList.add("js-window-scrolled");
        this.headerElement.style.transform = "translateY(0px)";
        if (countdownElement) {
          countdownElement.style.opacity = "0";
          countdownElement.style.pointerEvents = "none";
        }
        meta_theme_default.setDefaultColor();
      }
    });
    /**
     * Show announcement bar.
     */
    __publicField(this, "showAnnouncementBar", () => {
      const announcementBarHeight = this.announcementBarElement.offsetHeight;
      const countdownElement = document.querySelector(".announcement-bar__countdown");
      const countdownHeight = countdownElement ? countdownElement.offsetHeight : 0;
      const isMobile = window.innerWidth < 1024;
      const totalHeight = isMobile ? announcementBarHeight + countdownHeight : announcementBarHeight;
      if (this.headerElement && this.announcementBarElement) {
        this.annoucementBarState = "visible";
        this.headerElement.style.transform = `translateY(${totalHeight}px)`;
        this.announcementBarElement.style.clipPath = "inset(0% 0% 0 0%)";
        this.announcementBarElement.classList.remove("js-window-scrolled");
        this.headerElement.classList.remove("js-window-scrolled");
        if (countdownElement) {
          countdownElement.style.opacity = "1";
          countdownElement.style.pointerEvents = "auto";
        }
        meta_theme_default.setAnnouncementBarColor();
      }
    });
    __publicField(this, "handleWindowScroll", () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > this.offset) {
        if (this.annoucementBarState === "visible") {
          this.hideAnnouncementBar();
        }
      } else {
        this.showAnnouncementBar();
      }
    });
    /**
     * Handle announcement bar scroll.
     * 
     * @param {string} defaultState 
     */
    __publicField(this, "handleAnnouncementBarScroll", (defaultState) => {
      if (defaultState && defaultState === "visibile") {
        this.showAnnouncementBar();
      }
      window.addEventListener("scroll", () => this.handleWindowScroll());
    });
    this.announcementBarElement = document.querySelector('announcement-bar[data-role="announcement-bar"]');
    this.announcementBarHeight = this.announcementBarElement.offsetHeight;
    this.headerElement = document.querySelector(".header");
    this.countdownElement = document.querySelector(".announcement-bar__countdown");
    this.headerHeight = this.headerElement.offsetHeight;
    this.countdownHeight = this.countdownElement ? this.countdownElement.offsetHeight : 0;
    const isMobile = window.innerWidth < 1024;
    const totalAnnouncementHeight = isMobile ? this.announcementBarHeight + this.countdownHeight : this.announcementBarHeight;
    this.offset = totalAnnouncementHeight * 3;
    this.annoucementBarState = "visible";
  }
};
var { hideAnnouncementBar, showAnnouncementBar, handleAnnouncementBarScroll } = new AnnoucementBar();

// src/utils/body-lock.js
var bodyLock = class {
  /**
   * lock the body to prevent scrolling.
   */
  lock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.add("js-scroll-lock");
  }
  /**
   * unlock the scrolling of the body.
   */
  unlock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.remove("js-scroll-lock");
  }
};
var body_lock_default = new bodyLock();

// src/extenders/mobile-navigation.js
var MobileNavigation = class extends HTMLElement {
  constructor() {
    super();
    /**
     * Open mobile navigation.
     */
    __publicField(this, "openMobileNavigation", () => {
      const mobileNavigationElement = document.querySelector(".mobile-navigation");
      const mobileNavigationButtonElement = document.querySelector(".js-toggle-mobile-menu");
      const headerElement = document.querySelector(".header");
      const ariaControlValue = "mobile-navigation";
      const allSameAriaControlsElements = document.querySelectorAll(`button[aria-controls="${ariaControlValue}"]`);
      mobileNavigationElement.classList.add("js-mobile-navigation-open");
      mobileNavigationButtonElement.classList.add("js-open");
      mobileNavigationButtonElement.classList.remove("js-closed");
      headerElement.classList.add("js-active");
      hideAnnouncementBar();
      allSameAriaControlsElements.forEach((sameAriaControlsElement) => {
        sameAriaControlsElement.setAttribute("aria-expanded", "true");
        sameAriaControlsElement.classList.remove("js-initial");
      });
      body_lock_default.lock();
    });
    /**
     * Close mobile navigation.
     */
    __publicField(this, "closeMobileNavigation", () => {
      const mobileNavigationElement = document.querySelector(".mobile-navigation");
      const mobileNavigationButtonElement = document.querySelector(".js-toggle-mobile-menu");
      const headerElement = document.querySelector(".header");
      const allNavigationLayers = mobileNavigationElement.querySelectorAll(".navigation-layer");
      const announcementBarElement = document.querySelector('announcement-bar[data-role="announcement-bar"]');
      const countdownElement = document.querySelector(".announcement-bar__countdown");
      const announcementBarHeight = announcementBarElement.offsetHeight;
      const countdownHeight = countdownElement ? countdownElement.offsetHeight : 0;
      const isMobile = window.innerWidth < 1024;
      const totalHeight = isMobile ? announcementBarHeight + countdownHeight : announcementBarHeight;
      const offset = totalHeight * 3;
      const scrollPosition = window.scrollY;
      const ariaControlValue = "mobile-navigation";
      const allSameAriaControlsElements = document.querySelectorAll(`button[aria-controls="${ariaControlValue}"]`);
      mobileNavigationElement.classList.remove("js-mobile-navigation-open");
      mobileNavigationButtonElement.classList.remove("js-open");
      mobileNavigationButtonElement.classList.add("js-closed");
      headerElement.classList.remove("js-active");
      allNavigationLayers.forEach((navigationLayer) => {
        navigationLayer.classList.remove("js-active");
      });
      if (scrollPosition < offset) {
        showAnnouncementBar();
      }
      allSameAriaControlsElements.forEach((sameAriaControlsElement) => {
        sameAriaControlsElement.setAttribute("aria-expanded", "false");
        sameAriaControlsElement.classList.remove("js-initial");
      });
      body_lock_default.unlock();
    });
    this.mobileNavigationElement = this;
    const handleMobileNavigation = () => {
      const allMobileNavigationButtons = document.querySelectorAll(".js-toggle-mobile-menu");
      allMobileNavigationButtons.forEach((mobileNavigationButton) => {
        mobileNavigationButton.addEventListener("click", () => {
          const ariaExpanded = mobileNavigationButton.getAttribute("aria-expanded");
          if (ariaExpanded === "true") {
            this.closeMobileNavigation();
          } else {
            this.openMobileNavigation();
          }
        });
      });
    };
    handleMobileNavigation();
  }
};
if (customElements.get("mobile-navigation") === void 0) {
  customElements.define("mobile-navigation", MobileNavigation);
}
